import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { ILink } from '../../types/link';
import { Link } from 'react-router-dom';

export default class TrailerNumber extends React.Component<GridCustomCellProps> {
    render() {
        if (!this.props.field) return null;

        const link = this.props.dataItem.Links.filter((x: ILink) => x.Name === 'TrailerProfile');

        return (
            <td {...this.props.tdProps}>
                {link.length > 0 && <Link
                    to={link[0].Link}
                    style={{ color: '#007bff' }}
                >
                    {this.props.dataItem.TrailerNumber}
                </Link>}
            </td>
        );
    }

    public shouldComponentUpdate(nextProps: GridCustomCellProps) {
        return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
    }
}
